import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutP44Control extends Layout {
    labelOptions: Label;
    labelT: Label;
    panelActive: Panel;
    panelOptions: Panel;
    panelSmc3Control: Panel;
    panelTransitDays: Panel;
    sourceContractManagementControl: DataSource;
    switchActive: Switch;
    switchEnableTendering: Switch;
    switchEnableVolume: Switch;
    switchIncludeSaturday: Switch;
    switchIncludeSunday: Switch;
    switchPrompt: Switch;
    textboxAccountPassword: Textbox;
    textboxAccountUserId: Textbox;
    textboxEndpointUrl: Textbox;
    textboxP44ProfileId: Textbox;
    textboxRefSetting1: Textbox;
    textboxUnsupportedDispBrkStatus: Textbox;
}
